import { createFormShare } from '@commenda/api';
import { useCallback } from 'react';

import { CreateExternalShareDialog } from '../../external-share';
import { buildShareFormUrl } from './share-form-url';

interface IShareFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  serviceRequestId: string | null;
  taskId: number | null;
  defaultName?: string;
  onCreated?: () => void;
}

export function ShareFormDialog({
  isOpen,
  onClose,
  serviceRequestId,
  taskId,
  defaultName,
  onCreated,
}: IShareFormDialogProps) {
  const handleCreate = useCallback(
    async (input: {
      name: string;
      password?: string;
      expiresAt: string | null;
    }) => {
      if (!serviceRequestId || taskId == null) {
        throw new Error('This form cannot be shared.');
      }

      const { share } = await createFormShare({
        name: input.name,
        serviceRequestId,
        taskId,
        password: input.password,
        expiresAt: input.expiresAt,
      });

      return share;
    },
    [serviceRequestId, taskId]
  );

  return (
    <CreateExternalShareDialog
      open={isOpen}
      onOpenChange={(next) => !next && onClose()}
      description="Anyone with the link can fill and submit this form without signing in. Their answers land on this service request exactly as if they had filled it in the app."
      defaultName={defaultName}
      submitDisabled={!serviceRequestId || taskId == null}
      createShare={handleCreate}
      buildShareLink={buildShareFormUrl}
      onCreated={onCreated}
    />
  );
}
